export default __webpack_public_path__ + "static/media/Menu.6c109d7c.svg";